export enum FlightCategory {
  PatrolPassenger = 6,
  ConstructionWork = 2,
  ContractorConstruction = 3,
  DroneFlightInternal = 4,
  DroneFlightExternal = 5,
  ContractorPatrol = 1,
}

export enum DroneInternalFlightType {
  LeakSurvey = 'Drone - Leak Survey',
  CGI = 'Drone - CGI',
}
